import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { ActivityHistoryComponent } from './layouts/activity-history/activity-history.component';
import { CreatePasswordComponent } from './layouts/create-password/create-password.component';
import { FaqSupportComponent } from './layouts/faq-support/faq-support/faq-support.component';
import { GoogleFbSignupComponent } from './layouts/google-fb-signup/google-fb-signup.component';
import { LicenseSummaryComponent } from './layouts/license-summary/license-summary.component';
import { MainContentComponent } from './layouts/main-content/main-content.component';
import { ManageDeviceComponent } from './layouts/manage-device/manage-device.component';
import { ManageDeviceControlComponent } from './layouts/manage-device-control/manage-device-control.component';
import { ManageUserComponent } from './layouts/manage-user/manage-user.component';
import { MyAccountComponent } from './layouts/my-account/my-account.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { MainComponent } from './views/main/main.component';
import { AddDeviceComponent } from './layouts/add-device/add-device.component';
import { ParentalControlComponent } from './layouts/parental-control/parental-control.component';
import { ScoreManagementComponent } from './layouts/score-management/score-management.component';
import { LinkExpiredComponent } from './layouts/link-expired/link-expired.component';
import { LocateComponent } from './layouts/locate/locate.component';
import { LockComponent } from './layouts/lock/lock.component';
import { ScanDeviceComponent } from './layouts/scan-device/scan-device.component';
import { AntiTheftComponent } from './layouts/anti-theft/anti-theft.component';
import { UpdateVirusComponent } from './layouts/update-virus/update-virus.component';
import { WipeComponent } from './layouts/wipe/wipe.component';
import { SyncDeviceComponent } from './layouts/sync-device/sync-device.component';
import { SecurityScoreComponent } from './layouts/security-score/security-score.component';
import { RingDeviceComponent } from './layouts/ring-device/ring-device.component';
import { SystemSignUpComponent } from './layouts/system-sign-up/system-sign-up.component';
import { SyncScoreComponent } from './layouts/sync-score/sync-score.component';
import { AddUserComponent } from './layouts/add-user/add-user.component';
import { ChangeOwnerComponent } from './layouts/change-owner/change-owner.component';
import { DesktopSettingsComponent } from './layouts/desktop-settings/desktop-settings.component';
import { NotificationViewMoreComponent } from './layouts/notification-view-more/notification-view-more.component';
import { ResetPasswordComponent } from './layouts/reset-password/reset-password.component';

const routes: Routes = [
  { path: '', component: MainComponent },
  { path: 'rsvc/login', component: MainComponent },
  { path: 'code=', component: MainComponent },
  { path: 'signup', component: GoogleFbSignupComponent },
  { path: 'signup?code=', component: GoogleFbSignupComponent },
  { path: 'create-new-password', component: CreatePasswordComponent },
  { path: 'system-sign-up', component: SystemSignUpComponent },
  { path: 'link-expired', component: LinkExpiredComponent },

  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    //component: DashboardComponent,
    children: [
      { path: 'main-content', component: MainContentComponent },
      { path: '', redirectTo: 'main-content', pathMatch: 'full' },
      { path: 'main-content', component: MainContentComponent },
      { path: '', redirectTo: 'main-content', pathMatch: 'full' },

      { path: 'manage-device', component: ManageDeviceComponent },
      { path: 'manage-device/:id', component: ManageDeviceComponent },
      { path: 'activity-history', component: ActivityHistoryComponent },
      { path: 'manage-user', component: ManageUserComponent },
      { path: 'license-summary', component: LicenseSummaryComponent },
      { path: 'license-summary/:id', component: LicenseSummaryComponent },
      { path: 'faq-support', component: FaqSupportComponent },
      { path: 'my-account', component: MyAccountComponent },
      { path: 'add-device', component: AddDeviceComponent },
      { path: 'add-user', component: AddUserComponent },
      { path: 'change-owner', component: ChangeOwnerComponent },
      { path: 'reports', component: ParentalControlComponent },
      { path: 'score-management', component: ScoreManagementComponent },
      { path: 'security-score/:id', component: SecurityScoreComponent },
      { path: 'security-score', component: SecurityScoreComponent },
      { path: 'locate-device/:id', component: LocateComponent },
      { path: 'lock-device/:id', component: LockComponent },
      { path: 'scan-device/:id', component: ScanDeviceComponent },
      { path: 'anti-theft-device/:id', component: AntiTheftComponent },
      { path: 'update-virus-device/:id', component: UpdateVirusComponent },
      { path: 'wipe-device/:id', component: WipeComponent },
      { path: 'sync-device/:id', component: SyncDeviceComponent },
      { path: 'ring-device/:id', component: RingDeviceComponent },
      { path: 'sync-score/:id', component: SyncScoreComponent },
      { path: 'desktop-settings', component: DesktopSettingsComponent },
      { path: 'desktop-settings/:id', component: DesktopSettingsComponent },
      {
        path: 'notification-view-more',
        component: NotificationViewMoreComponent,
      },

      { path: 'manage-device', component: ManageDeviceComponent },
      { path: 'manage-device/:id', component: ManageDeviceComponent },
      {
        path: 'manage-device-control',
        component: ManageDeviceControlComponent,
      },
      {
        path: 'manage-device-control/:id',
        component: ManageDeviceControlComponent,
      },
      { path: 'activity-history', component: ActivityHistoryComponent },
      { path: 'manage-user', component: ManageUserComponent },
      { path: 'license-summary', component: LicenseSummaryComponent },
      { path: 'license-summary/:id', component: LicenseSummaryComponent },
      { path: 'faq-support', component: FaqSupportComponent },
      { path: 'my-account', component: MyAccountComponent },
      { path: 'add-device', component: AddDeviceComponent },
      { path: 'add-user', component: AddUserComponent },
      { path: 'change-owner', component: ChangeOwnerComponent },
      { path: 'reports', component: ParentalControlComponent },
      { path: 'score-management', component: ScoreManagementComponent },
      { path: 'security-score/:id', component: SecurityScoreComponent },
      { path: 'security-score', component: SecurityScoreComponent },
      { path: 'locate-device/:id', component: LocateComponent },
      { path: 'lock-device/:id', component: LockComponent },
      { path: 'scan-device/:id', component: ScanDeviceComponent },
      { path: 'anti-theft-device/:id', component: AntiTheftComponent },
      { path: 'update-virus-device/:id', component: UpdateVirusComponent },
      { path: 'wipe-device/:id', component: WipeComponent },
      { path: 'sync-device/:id', component: SyncDeviceComponent },
      { path: 'ring-device/:id', component: RingDeviceComponent },
      { path: 'sync-score/:id', component: SyncScoreComponent },
      { path: 'desktop-settings', component: DesktopSettingsComponent },
      { path: 'desktop-settings/:id', component: DesktopSettingsComponent },
    ],
  },
  { path: 'create-password', component: CreatePasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent }
  // { path: "**", redirectTo: "", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
